/**
 * A gyro's lean rate is measured where the true rate is zero: upright and
 * moving. The RaceBox unit ships a 2.5–5°/s roll-rate offset that the
 * complementary filter otherwise integrates into a constant lean offset
 * (α·b·dt/(1−α): 1.3 s × bias at 25 Hz, 3.2 s × bias at 10 Hz).
 */
export const GYRO_BIAS_MAX_LEAN_DEG = 5

export const GYRO_BIAS_MIN_SPEED_KMH = 30

/**
 * Below this much upright riding the whole span's median stands in, and
 * below this much riding at all the offset is unmeasured: 20 s of upright
 * ticks on a two-lap GoPro span read +0.8°/s where the full session reads
 * −1.2°/s.
 */
export const GYRO_BIAS_MIN_UPRIGHT_S = 30

/** A tick counts at most this much time toward the riding budget, so a recording gap is not riding. */
export const GYRO_BIAS_MAX_TICK_GAP_MS = 500
